import classNames from 'classnames';
import React from 'react';

import Checkbox from 'ui/base/Checkbox';

import { checkboxStyle, ImportListItem } from './UI';

/**
 * @typedef {{
 *  maxWidth?: number;
 *  className?: string;
 *  render?: React.ReactNode;
 * }} ColumnProps
 */

/**
 * @typedef {{
 *  selected?: boolean;
 *  disabled?: boolean;
 *  onClick: () => void;
 *  'data-cy'?: string;
 * }} ImportListProps
 */

/** @type {React.FC<React.PropsWithChildren<ImportListProps>>} */
const Item = ({ selected, disabled, onClick, 'data-cy': dataCy, children }) => {
  /**
   * @param {React.MouseEvent} event
   */
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) {
      onClick();
    }
  };

  return (
    <ImportListItem data-cy={dataCy} className={classNames('mb-2', { selected })} onClick={handleClick}>
      <Checkbox checked={selected} className={checkboxStyle} disabled={disabled}>
        {children}
      </Checkbox>
    </ImportListItem>
  );
};

export default Item;
